(() => {
  const initialize = (root) => {
    if (root.dataset.oneshotCampoReady === 'true') return;

    const track = root.querySelector('.oneshot-campo__track');
    const previousButton = root.querySelector('.oneshot-campo__control--previous');
    const nextButton = root.querySelector('.oneshot-campo__control--next');

    if (!track || !previousButton || !nextButton) return;

    const slides = Array.from(track.querySelectorAll('.oneshot-campo__slide'));
    if (slides.length === 0) return;

    root.dataset.oneshotCampoReady = 'true';

    let updateFrame;

    const updateButtons = () => {
      const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const currentScroll = Math.max(0, track.scrollLeft);

      previousButton.disabled = currentScroll <= 1;
      nextButton.disabled = maximumScroll <= 1 || currentScroll >= maximumScroll - 1;
    };

    const scheduleButtonUpdate = () => {
      if (updateFrame) cancelAnimationFrame(updateFrame);
      updateFrame = requestAnimationFrame(updateButtons);
    };

    const getScrollStep = () => {
      if (slides.length < 2) return slides[0].getBoundingClientRect().width;
      return Math.abs(slides[1].offsetLeft - slides[0].offsetLeft);
    };

    previousButton.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollStep() });
    });

    nextButton.addEventListener('click', () => {
      track.scrollBy({ left: getScrollStep() });
    });

    track.addEventListener('scroll', scheduleButtonUpdate, { passive: true });
    track.addEventListener('focusin', (event) => {
      const slide = event.target.closest('.oneshot-campo__slide');
      if (!slide) return;

      slide.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(scheduleButtonUpdate).observe(track);
    } else {
      window.addEventListener('resize', scheduleButtonUpdate);
    }

    const preloadSlideImages = (slide) => {
      slide.querySelectorAll('img[loading="lazy"]').forEach((image) => {
        image.loading = 'eager';
      });
    };

    if ('IntersectionObserver' in window) {
      const preloadObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            preloadSlideImages(entry.target);
            preloadObserver.unobserve(entry.target);
          });
        },
        { root: track, rootMargin: '0px 100%' }
      );
      slides.forEach((slide) => preloadObserver.observe(slide));
    } else {
      slides.forEach(preloadSlideImages);
    }

    scheduleButtonUpdate();
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.('[data-oneshot-campo-slider]')) initialize(scope);
    scope.querySelectorAll?.('[data-oneshot-campo-slider]').forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
